import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { listUsers, Usuario } from "src/app/models/user-model";
import { UsersService } from "src/app/services/users/users.service";

@Component({
  selector: "app-usuario-list",
  templateUrl: "./usuario-list.component.html",
  styleUrls: ["./usuario-list.component.css"],
  providers: [UsersService],
})
export class usuarioListComponent implements OnInit {
  public mostrar: boolean = true;
  public usuario: any[] = [];
  public cols: any = [];
  public es: any;
  public EtiquetaInfo: any = [];
  public display: boolean = false;
  public database = "usuario";
  public date2: Date;
  public displayUser = false;
  public first = 0;

  listarTodos: boolean = true;
  mostrarInformes: boolean = true;
  showInfo: boolean = true;
  showDuplicate: boolean = false;
  showTables: boolean = true;

  columnasVisibles: boolean = false;
  anchoTabla = "1500px";
  selectedColumns: any[];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private usuarioService: UsersService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit() {
    this.es = {
      firstDayOfWeek: 1,
      dayNames: [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado",
      ],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
      monthNames: [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ],
      monthNamesShort: [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic",
      ],
      today: "Hoy",
      clear: "Borrar",
    };

    this.cols = [
      { field: "nombre", header: "Nombre" },
      { field: "role", header: "Role" },
      { field: "eliminado", header: "Activo" },
      { field: "read_only", header: "Lectura" },
      { field: "opciones", header: "Opciones" },
    ];

    this.iniciar();
  }

  iniciar() {
    this.usuarioService
      .getAllUsers()
      .toPromise()
      .then((resp: Usuario[]) => {
        this.usuario = resp.map((element) => {
          element.eliminado = element.eliminado == "1" ? "NO" : "SI";
          element.read_only = element.read_only == "1" ? "SI" : "NO";
          return element;
        });
        this.recuperarPosicion();
      })
      .catch((error) => {
        console.log("Error", error);
      });
  }

  crear() {
    this.router.navigate(["crear"], { relativeTo: this.route });
  }

  delete(usuario) {
    if (usuario.nombre == "Admin" && usuario.role == "ROLE_ADMIN") {
      this.displayUser = true;
    } else {
      this.confirmationService.confirm({
        header: "Confirmación",
        acceptLabel: "Acceptar",
        rejectLabel: "Cancelar",
        message: "Quieres eliminar este registro?",
        accept: () => {
          this.usuarioService.deleteUser(usuario, "users").subscribe(
            (resp) => {
              this.iniciar();
            },
            (error) => {
              console.log("delete error ", error);
            }
          );
        },
      });
    }
  }

  recuperarPosicion() {
    try {
      if (
        localStorage.getItem("guardar_posicion") !== null ||
        localStorage.getItem("guardar_posicion") !== undefined ||
        localStorage.getItem("guardar_posicion").localeCompare("") !== 0
      ) {
        this.first = Number(localStorage.getItem("guardar_posicion"));
        if (this.first < 10) {
          this.first = 0;
        }
        localStorage.setItem("guardar_posicion", "");
      } else {
        this.first = 0;
      }
    } catch (error) {
      this.first = 0;
    }
  }

  update(id, index) {
    localStorage.setItem("guardar_posicion", index.toString());
    this.router.navigate(["edit", id], { relativeTo: this.route });
  }

  mostarTabla() {
    this.mostrar = true;
  }

  showSuccess() {
    //this.messageService.add({severity:'success', summary:'Registro usuario', detail:'Registro usuario Añadido'});
  }

  info(etiqueta) {
    this.EtiquetaInfo = etiqueta;
    console.log(this.EtiquetaInfo.id);
    this.display = true;
  }

  closeWindow() {
    this.display = false;
  }

  filtrarFecha(event, dt, col) {
    if (event == null || event == "" || event == undefined) {
      dt.filter(null, "fecha", col.filterMatchMode);
    } else {
      let myfecha = new Date(event);
      let mes = myfecha.getMonth() + 1;
      let mesCorregido = "";
      let dia = myfecha.getDate();
      let diaCorregido = "";
      if (mes < 10) {
        mesCorregido = "0" + mes;
      } else {
        mesCorregido = "" + mes;
      }
      if (dia < 10) {
        diaCorregido = "0" + dia;
      } else {
        diaCorregido = "" + dia;
      }

      let segmentarFEcha =
        diaCorregido + "/" + mesCorregido + "/" + myfecha.getFullYear();

      dt.filter(segmentarFEcha, "fecha", col.filterMatchMode);
    }
  }

  columnasSimples() {
    this.columnasVisibles = false;
    this.anchoTabla = "1500px";
    this.selectedColumns = this.cols;
  }
  columnasTotales() {
    this.columnasVisibles = false;
    this.anchoTabla = "4000px";
    this.selectedColumns = this.cols;
  }

  listarCampos() {
    if (this.showTables) {
      this.showTables = false;
      this.columnasTotales();
    } else {
      this.showTables = true;
      this.columnasSimples();
    }
  }
}
